import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { 
	AUTH_PREFIX_PATH, 
	APP_PREFIX_PATH,
	UNAUTHENTICATED_ENTRY, 
	REDIRECT_URL_KEY 
} from 'configs/AppConfig'
import { USER_INFO } from 'constants/AuthConstant'

const ProtectedRoute = () => {
	
	const { token, mustChangePassword, user } = useSelector(state => state.auth)
	const location = useLocation()

	if (!token) {
		return <Navigate to={`${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}

	// If user must change password, redirect to set-password page
	if (mustChangePassword && location.pathname !== `${AUTH_PREFIX_PATH}/set-password`) {
		return <Navigate to={`${AUTH_PREFIX_PATH}/set-password`} replace />;
	}
	
	// Check if kiosk user trying to access non-kiosk routes
	const storedUser = JSON.parse(localStorage.getItem(USER_INFO) || '{}');
	const isKioskUser = user?.isKioskUser === true || storedUser?.isKioskUser === true;
	const isKioskDevice = localStorage.getItem('is_kiosk_device') === 'true';
	const isOnKioskRoute = location.pathname.includes('/kiosk');
	
	// If kiosk user/device and NOT on kiosk route, redirect to kiosk
	if ((isKioskUser || isKioskDevice) && !isOnKioskRoute) {
		console.log('[ProtectedRoute] Kiosk user/device on non-kiosk route, redirecting...');
		return <Navigate to={`${APP_PREFIX_PATH}/kiosk`} replace />;
	}

	return <Outlet />
}

export default ProtectedRoute
